import { AsyncPipe } from '@angular/common';
import { Component, inject, input, output } from '@angular/core';
import { LoginMenuComponent } from '@shared/components/login-menu/login-menu.component';
import { BrandingData, ClientApps } from '@shared/models';
import { BrandingService } from '@shared/services/branding.service';
import { Observable } from 'rxjs';

@Component({
  selector: 'lib-header',
  templateUrl: 'header.component.html',
  styleUrls: ['header.component.scss'],
  imports: [LoginMenuComponent, AsyncPipe],
})
export class HeaderComponent {
  private readonly brandingService = inject(BrandingService);

  public readonly showNav = input(true);
  public readonly client = input.required<ClientApps>();
  public readonly showFeedback = output();
  public navbarOpen = false;
  public clientApp: ClientApps | undefined;

  public get branding$(): Observable<BrandingData | undefined> {
    return this.brandingService.branding$;
  }

  public toggleNavbar(): void {
    this.navbarOpen = !this.navbarOpen;
  }

  public showFeedbackModal() {
    this.showFeedback.emit(undefined);
  }
}
